(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[656],{

/***/ 6148:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo",
      function () {
        return __webpack_require__(2137);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ config; },
  "r": function() { return /* binding */ configSet; }
});

;// CONCATENATED MODULE: ./public/logo.png
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.84b77a51.png","height":407,"width":613,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAJFBMVEVMaXH4TSH/VCP3SyP6SCH5SSL4SB/6SB/7SCD3SCT5RyD4SCCUBaGTAAAADHRSTlMAFQoqRILQ65QjVptcvAuiAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAKElEQVR4nCXFuQ0AIBAEsdn7gf77RQInhkf6EwswWVSATVcfxzO3C10GQQBrpKbfmwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./lib/pageConfig.js

// eslint-disable-next-line import/prefer-default-export
const config = {
    siteName: "jackrabbitops",
    blogTitle: "Blog",
    baseUrl: "jackrabbitops.com",
    websiteLogo: logo,
    twitterHandle: "@junaid.sudo",
    twitterCardType: "JackRabbit Blog",
    css: {
        primaryColor: "#111",
        accentColor: "#455A64",
        lightGray: "#eeeeee",
        backgroundColor: "#fff",
        black: "#111",
        white: "#fff",
        textColor: "#333",
        opacity: 0.7
    }
};
const privacy = {
    ...config,
    siteDescription: "Privacy policy for AI project manager ",
    defaultPageTitle: "Privacy | JackRabbit Ops"
};
const FAQ = {
    ...config,
    siteDescription: "Frequently asked questions for Jackrabbit Ops",
    defaultPageTitle: "FAQ | JackRabbit Ops"
};
const landing = {
    ...config,
    siteDescription: "Respond instantly to all your leads, qualify them and book meetings all on autopilot. All at a fraction of the cost of an SDR. ",
    defaultPageTitle: "Never miss a new customer | Jackrabbit Ops "
};
const demo = {
    ...config,
    siteDescription: "See Jackrabbit Ops in action, instantly responding to RFQs and qualifying the leads for you.",
    defaultPageTitle: "Instantly qualify leads | Jackrabbit Ops "
};
const offer = {
    ...config,
    siteDescription: "Try for free. Upgrade to the low-cost paid plan of $16/user to unlock your team's success.",
    defaultPageTitle: "Pricing | JackRabbit Ops"
};
const thankYou = {
    ...config,
    siteDescription: "Our team will be in touch to get you onboarded for your AI project manager.",
    defaultPageTitle: "Get In Touch | JackRabbit Ops"
};
const blogHome = {
    ...config,
    siteDescription: "Explore project management best practices and latest news with Jackrabbit Ops.",
    defaultPageTitle: "Blog | JackRabbit Ops"
};
const features = {
    ...config,
    siteDescription: "Jackrabbit Ops AI manager recognizes roadblocks and highlights them to roles that can solve them.",
    defaultPageTitle: "AI Manager Features | JackRabbit Ops"
};
const challenge = {
    ...config,
    siteDescription: "Productive team or your money back",
    defaultPageTitle: "90 Day Challenge | JackRabbit Ops"
};
const configSet = {
    FAQ,
    features,
    privacy,
    landing,
    blogHome,
    offer,
    challenge,
    thankYou,
    demo
};


/***/ }),

/***/ 2137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Example; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7536);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(594);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var _utils_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3298);
/* harmony import */ var _lib_pageConfig__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3517);
/* harmony import */ var _components_container_base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5216);







//COMPONENTS

function Example() {
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [complete, setComplete] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { register , handleSubmit , formState: { errors  }  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .useForm */ .cI)();
    async function testSystem(data) {
        setLoading(true);
        const response = await axios__WEBPACK_IMPORTED_MODULE_7__/* ["default"].post */ .Z.post("https://jro-backend.onrender.com/webhooks/webform/L9Uyc5ZmRm/", data, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        });
        setLoading(false);
        setComplete(true);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full bg-white",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
                ...(0,_utils_seo__WEBPACK_IMPORTED_MODULE_3__/* .createSEOPageConfig */ .Cd)(_lib_pageConfig__WEBPACK_IMPORTED_MODULE_4__/* .configSet.demo */ .r.demo)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_container_base__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "isolate bg-white px-6 py-24 lg:px-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute inset-x-0 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative left-1/2 -z-10 aspect-[1155/678] w-[36.125rem] max-w-none -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-jackOrange opacity-30 sm:left-[calc(50%-40rem)] sm:w-[72.1875rem]",
                                    style: {
                                        clipPath: "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mx-auto max-w-2xl text-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl",
                                        children: "See Jackrabbit in Action"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mt-2 text-lg leading-8 text-gray-600",
                                        children: "Fill the form and our AI will instantly reply and qualify you."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                onSubmit: handleSubmit(testSystem),
                                className: "mx-auto mt-16 max-w-xl sm:mt-20",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "sm:col-span-1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                        htmlFor: "first-name",
                                                        className: "block text-sm font-semibold leading-6 text-gray-900",
                                                        children: "Your Name"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "mt-2.5",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                            type: "text",
                                                            name: "first-name",
                                                            id: "first-name",
                                                            autoComplete: "given-name",
                                                            ...register("name", {
                                                                required: true
                                                            }),
                                                            className: "block w-full rounded-md border px-3.5 py-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "sm:col-span-1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                        htmlFor: "first-name",
                                                        className: "block text-sm font-semibold leading-6 text-gray-900",
                                                        children: "Company"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "mt-2.5",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                            type: "text",
                                                            name: "first-name",
                                                            id: "first-name",
                                                            autoComplete: "given-name",
                                                            ...register("company_name", {
                                                                required: true
                                                            }),
                                                            className: "block w-full rounded-md border px-3.5 py-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "sm:col-span-2",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                        htmlFor: "email",
                                                        className: "block text-sm font-semibold leading-6 text-gray-900",
                                                        children: "Email"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "mt-2.5",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                            type: "email",
                                                            name: "email",
                                                            id: "email",
                                                            autoComplete: "email",
                                                            ...register("email", {
                                                                required: true
                                                            }),
                                                            className: "block w-full rounded-md border px-3.5 py-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "sm:col-span-2",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                        htmlFor: "message",
                                                        className: "block text-sm font-semibold leading-6 text-gray-900",
                                                        children: "Message"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "mt-2.5",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                                                            name: "message",
                                                            id: "message",
                                                            rows: 4,
                                                            ...register("message", {
                                                                required: true
                                                            }),
                                                            className: "block w-full rounded-md border px-3.5 py-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6",
                                                            defaultValue: ""
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mt-10",
                                        children: complete ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-center text-green-600 font-header text-lg",
                                            children: "Check your email!"
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                            type: "submit",
                                            disabled: loading,
                                            className: "flex flex-row items-center justify-center gap-4 w-full rounded-md bg-black px-3.5 py-3 text-center text-sm font-semibold text-white shadow-sm hover:bg-white hover:text-black border border-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
                                            children: [
                                                "Submit RFQ",
                                                loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                    className: "animate-spin h-6 w-6 self-center mr-2",
                                                    fill: "currentColor",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 40 40",
                                                    enableBackground: "new 0 0 40 40",
                                                    xml: "preserve",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            opacity: "0.2",
                                                            d: "M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            d: "M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 3298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ createSEOPageConfig; },
/* harmony export */   "JV": function() { return /* binding */ BlogSeo; },
/* harmony export */   "WQ": function() { return /* binding */ createSEOConfig; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3517);



const getImage = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (data.imageUrl) {
        return [
            {
                url: data.imageUrl,
                width: 600,
                height: 300,
                alt: data.title
            }
        ];
    }
    if (data.slug) {
        return [
            {
                url: "/api/blog-image/".concat(data.slug),
                width: 600,
                height: 300,
                alt: data.title
            }
        ];
    }
    return [
        {
            url: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.websiteLogo */ .v.websiteLogo,
            width: 280,
            height: 280,
            alt: "JRO"
        }
    ];
};
function BlogSeo(param) {
    let { data  } = param;
    if (!data) return null;
    const description = data.seoDescription ? data.seoDescription : _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteDescription */ .v.siteDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .ArticleJsonLd */ .dX, {
        url: data.canonicalUrl,
        title: data.title,
        images: getImage(data).map((file)=>file.url),
        datePublished: data.publishDate,
        dateModified: data.modifiedDate,
        authorName: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.author */ .v.author,
        publisherName: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.author */ .v.author,
        publisherLogo: "https://www.example.com/photos/logo.jpg",
        description: description
    });
}
function createSEOConfig() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const title = data.title || _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.defaultPageTitle */ .v.defaultPageTitle;
    const description = data.seoDescription ? data.seoDescription : _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteDescription */ .v.siteDescription;
    return {
        title,
        description,
        openGraph: {
            type: "website",
            locale: "en_US",
            url: data.canonicalUrl,
            title,
            description,
            images: getImage(data),
            site_name: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteName */ .v.siteName
        },
        twitter: {
            handle: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterHandle */ .v.twitterHandle,
            site: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterHandle */ .v.twitterHandle,
            cardType: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterCardType */ .v.twitterCardType
        }
    };
}
function createSEOPageConfig() {
    let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!config) return null;
    const title = config.defaultPageTitle;
    const description = config.siteDescription;
    return {
        title,
        description,
        openGraph: {
            type: "website",
            locale: "en_US",
            url: config.canonicalUrl,
            title,
            description,
            images: getImage(config),
            site_name: config.siteName
        },
        twitter: {
            handle: config.twitterHandle,
            site: config.twitterHandle,
            cardType: config.twitterCardType
        }
    };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [862,962,594,536,216,774,888,179], function() { return __webpack_exec__(6148); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);